import React, { FunctionComponent, useState } from "react";
import { TextField, Button, FormControlLabel, Checkbox, FormControl, FormLabel, FormGroup } from "@material-ui/core";

import style from "./editor.module.scss";

const uneditable = [
  "createdAt",
  "updatedAt",
  "id",
  "uuid",
  "emailSentId",
];

const prios = [
  "Gravidanza",
  "Disabilita",
  "> 65anni",
  "VIP",
];

const customTypes = (key: any): string => {
  return {
    validUntil: "date",
    expiresAt: "date",
  }[key] || "text";
};

export const Editor = ({
  data = {},
  entity = "",
  keyTitle = "",
  newRecord = false,
  onSave = (table: any, newData: any) => {},
  onCancel = () => {},
}) => {

  const [ inputs, setInput ] = useState<any>(newRecord ? {} : data);

  return (<div className={style["wrapper"]}>
      <h1 className={style["title"]}> {newRecord ? "Create" : `Edit: ${data[keyTitle] || keyTitle}` } </h1>
      <div className={style["input-wrapper"]}>
        {Object.entries(data).map(([ key ]: any) => {
          if (key === "priorities") {
            return (<FormControl style={{ marginTop: "36px" }}>
              <FormLabel> Priorita </FormLabel>
              <FormGroup>
                {prios.map((item, index) => {
                  const statePrio = inputs?.priorities || [];
                  return (<FormControlLabel
                    value="right"
                    control={<Checkbox
                      color="primary"
                      checked={statePrio[index] || false}
                      onChange={(e, checked) => {
                        const newPrios = [...statePrio];
                        newPrios[index] = checked;
                        setInput({
                          ...inputs,
                          priorities: newPrios,
                        });
                      }}
                    />}
                    label={item}
                    labelPlacement="end"
                  />);
                })}
              </FormGroup>
            </FormControl>);
          }
          return (<TextField
            key={key}
            value={inputs[key] ?? ""}
            label={key}
            type={customTypes(key)}
            name="somenm"
            disabled={uneditable.indexOf(key) >= 0}
            onChange={(e) => setInput({ ...inputs, [key]: e.target.value })}
            className={style["text-field"]}
            variant="filled"
          />);
        })}
        <div className={style["buttons-wrapper"]}>
          <div className={style["button"]}>
            <Button
              onClick={() => onSave(entity, inputs)}
              variant="contained"
              color="primary"
            > {newRecord ? "CREATE" : "SAVE"}</Button>
          </div>
          <div className={style["button"]}>
            <Button
              onClick={onCancel}
              variant="outlined"
            > Cancel </Button>
          </div>
        </div>
      </div>
    </div>);
};
